module.exports = __webpack_public_path__ + "img/bio_thawer.7d5e5160.png";